<template lang="pug">
td.vue-time-entries-weekly-table-row-table-data.text-center(
  v-if="timeEntriesIsEmpty"
  :class="{ 'is-empty': isEditEnabled, 'is-today': isToday(date) && !isArchivedProject(project), archived: isArchivedProject(project), disabled: addButtonDisabled }"
  @click="openTimeEntriesFormDialog"
)
  span(v-if="!isEditEnabled")
  .hi-plus-circle.hi-20(v-else)
td.vue-time-entries-weekly-table-row-table-data.project_row.text-center(
  v-else
  :class="{ 'is-today': isToday(date) && !isArchivedProject(project), archived: isArchivedProject(project) }"
)
  div(v-if="manualTimeEntryRequests.length > 0")
    span.d-flex.align-items-center.justify-content-center(v-if="isArchivedProject(project)")
      | {{ sumDuration(timeEntries) | formatDuration }}
      ManualTimeEntryRequestWeeklyListPopover(:manual-time-entry-requests="manualTimeEntryRequests")
    span.d-flex.align-items-center.justify-content-center(v-else-if="isCopy")
      div(
        v-tooltip="true"
        data-original-title="Refresh page to edit"
      )
        | {{ sumDuration(timeEntries) | formatDuration }}
      ManualTimeEntryRequestWeeklyListPopover(:manual-time-entry-requests="manualTimeEntryRequests")
    span.d-flex.align-items-center.justify-content-center(v-else)
      TimeEntriesOvertimePopover(
        :time-entries="timeEntries"
        :organization="organization"
        :show-financial="isOwner"
        show-overtime
        container-classes="mr-5"
      )
      TimeEntriesWeeklyListPopover(
        ref="TimeEntriesWeeklyListPopover"
        :time-entries="timeEntries"
        :work-break-policy-id="workBreakPolicyId"
        :add-manual-break-enabled="addManualBreakEnabled"
        container-classes=""
      )
        span.time-entries-weekly-duration(slot="trigger")
          | {{ sumDuration(timeEntries) | formatDuration }}
      ManualTimeEntryRequestWeeklyListPopover(:manual-time-entry-requests="manualTimeEntryRequests")
  div(v-else)
    span(v-if="isArchivedProject(project)")
      | {{ sumDuration(timeEntries) | formatDuration }}
    span(v-else-if="isCopy")
      div(
        v-tooltip="true"
        data-original-title="Refresh page to edit"
      )
        | {{ sumDuration(timeEntries) | formatDuration }}
    span.d-flex.align-items-center.justify-content-center(v-else)
      TimeEntriesOvertimePopover(
        :time-entries="timeEntries"
        :organization="organization"
        :show-financial="isOwner"
        show-overtime
        container-classes="mr-5"
      )
      TimeEntriesWeeklyListPopover(
        ref="TimeEntriesWeeklyListPopover"
        :time-entries="timeEntries"
        :work-break-policy-id="workBreakPolicyId"
        :add-manual-break-enabled="addManualBreakEnabled"
        container-classes=""
      )
        span.time-entries-weekly-duration(slot="trigger")
          | {{ sumDuration(timeEntries) | formatDuration }}
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { isEmpty } from 'lodash-es';
import ManualTimeEntryRequestWeeklyListPopover from './ManualTimeEntryRequestWeeklyListPopover.vue';

export default {
  name: 'TimeEntriesWeeklyTableRowTableData',
  components: {
    ManualTimeEntryRequestWeeklyListPopover,
  },
  props: {
    timeEntries: Array,
    date: Object,
    isCopy: Boolean,
    project: null,
    task: null,
    workBreakPolicyId: null,
  },
  computed: {
    ...mapState({ isOwner: 'is_owner' }),
    ...mapGetters([
      'managedProjectIds',
      'sumDuration',
      'currentZone',
      'newTimeEntry',
      'organization',
      'projects',
      'tasks',
      'isArchivedProject',
      'isBeforeRetentionDate',
      'isToday',
      'lockedRangeFor',
      'isFuture',
      'workBreaksEnabled',
    ]),
    ...mapGetters({
      isAddTimeDisabled: 'addTimeDisabled',
    }),
    lockedRange() {
      return this.lockedRangeFor(this.date);
    },
    dateIsTimesheetLocked() {
      return !!this.lockedRange.start && !!this.lockedRange.stop;
    },
    lockedTooltip() {
      return this.dateIsTimesheetLocked ? 'Timesheet is locked' : false;
    },
    addTimeDisabled() {
      return (
        this.isAddTimeDisabled ||
        this.isFuture(this.date) ||
        this.isArchivedProject(this.project) ||
        this.dateIsTimesheetLocked ||
        this.isBeforeRetentionDate(this.date)
      );
    },
    timeEntriesIsEmpty() {
      return isEmpty(this.timeEntries);
    },
    addManualBreakEnabled() {
      return this.workBreakPolicyId && this.workBreaksEnabled;
    },
    addButtonDisabled() {
      return (
        this.isFuture(this.date) ||
        this.isBeforeRetentionDate(this.date) ||
        this.dateIsTimesheetLocked ||
        (this.workBreakPolicyId && !this.addManualBreakEnabled)
      );
    },
    isEditEnabled() {
      if (this.workBreakPolicyId) {
        return !this.addTimeDisabled && this.addManualBreakEnabled;
      }

      return !this.addTimeDisabled;
    },
    manualTimeEntryRequests() {
      return this.timeEntries.filter((timeEntry) => timeEntry.manual_time_request === true);
    },
  },
  methods: {
    openPopover(event) {
      const popover = this.$refs.TimeEntriesWeeklyListPopover;

      if (event.target.classList.contains('glyphicon-time')) {
        return;
      }
      if (popover) {
        popover.open();
      }
    },
    openTimeEntriesFormDialog() {
      if (this.isEditEnabled) {
        const projectId = this.project ? this.project.id : null;
        const taskId = this.task ? this.task.id : null;
        const timeEntry = Object.assign({}, this.newTimeEntry, {
          start_time: this.date,
          stop_time: this.date,
          project_id: projectId,
          task_id: taskId,
          work_break_policy_id: this.workBreakPolicyId,
        });
        const type = this.isCopy ? 'weeklyCopy' : 'add';

        this.$store.dispatch('openDialog', { dialog: 'timeEntriesFormDialog', type, timeEntry });
      }
    },
  },
};
</script>
